exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teamhub {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column; }\n  .teamhub .app-content {\n    flex: 1 0 auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/teamhub/teamhub.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/teamhub/teamhub.scss
// module chunks = index